import { RegisteredComponent } from "@builder.io/sdk-react";
import { generalFormConfig } from "./generalFormConfig";

export const checkboxInputBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "Checkbox input",
    description:
      "The following state variables are expected: [name] for handling the value of the checkbox.",
    canHaveChildren: false,
    defaultStyles: {},
    defaults: {},
    shouldReceiveBuilderProps: {
      builderContext: true,
      builderBlock: true,
      builderComponents: true,
      builderLinkComponent: true,
    },
    inputs: [
      {
        name: "value",
        type: "boolean",
        localized: false,
      },
      {
        name: "onChange",
        type: "javascript",
        localized: false,
      },
      {
        name: "onChangeState",
        type: "javascript",
        localized: false,
      },
      {
        name: "onInitialize",
        type: "javascript",
        localized: false,
      },
      {
        name: "variant",
        type: "enum",
        localized: false,
        required: true,
        defaultValue: "form",
        enum: [
          {
            label: "Form",
            value: "form",
            helperText: "Rendering usually used for registration forms.",
          },
          {
            label: "Unstyled",
            value: "unstyled",
          },
        ],
      },
      {
        name: "label",
        type: "uiBlocks",
        localized: true,
        required: false,
        defaultValue: [
          {
            "@type": "@builder.io/sdk:Element",
            children: [
              {
                "@type": "@builder.io/sdk:Element",
                component: {
                  name: "Text",
                  options: {
                    text: {
                      "@type": "@builder.io/core:LocalizedValue",
                      Default: "Label",
                    },
                  },
                },
                meta: {
                  localizedTextInputs: ["text"],
                  "transformed.text": "localized",
                },
              },
            ],
          },
        ],
      },
      ...(generalFormConfig ?? []),
    ],
  };
